<template>
  <el-dialog :visible.sync="showGroup" width="540px" title="创建项目群" class="chat-new-group">
    <div class="user" v-if="!next">
      <div class="all">
        <el-input
          v-model="key"
          size="small"
          clearable
          class="all-search"
          prefix-icon="el-icon-search"
        ></el-input>
        <div class="box">
          <div class="item" v-for="u in computedUser" :key="u.ID">
            <div>{{u.name}} {{u.phone}}</div>
            <el-checkbox v-model="u.checked"></el-checkbox>
          </div>
        </div>
      </div>
      <div class="choosed">
        <div class="title">已选 {{choosed.length}}</div>
        <div class="box">
          <div class="item" v-for="c in choosed" :key="c.ID">{{c.name}}</div>
        </div>
      </div>
    </div>
    <div class="group-form" v-else>
      <el-form ref="group_form" :model="group_form" label-width="0">
        <el-form-item label style="text-align:center;">
          <el-input v-model="group_form.title" class="pro-input" placeholder="请输入群名称"></el-input>
        </el-form-item>
        <el-form-item style="text-align:center;" v-if="false">
          <el-button type="senkoo" @click="createGroup">确定</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="footer" slot="footer">
      <el-button type="default" size="small" @click="showGroup = false">取消</el-button>
      <el-button type="senkoo" v-if="!next" size="small" @click="toNext">下一步</el-button>
      <el-button type="senkoo" v-if="next" size="small" @click="createGroup">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: { show: Boolean },
  data() {
    return {
      group_form: { title: "" },
      next: false,
      group_users: [],
      users: [],
      page: {},
      key: ""
      // choosed: []
    };
  },
  computed: {
    showGroup: {
      get() {
        return this.show;
      },
      set(v) {
        this.$emit("update:show", v);
      }
    },
    choosed() {
      return this.users.filter(f => f.checked);
    },
    computedUser() {
      return this.users.filter(
        f => f.name.includes(this.key) || f.phone.includes(this.key)
      );
    }
  },
  created() {
    this.fetchUser();
  },
  methods: {
    toNext() {
      if (this.choosed.length == 0) {
        this.$message.error({ message: "请先选择成员" });
        return;
      }
      this.next = true;
    },
    fetchUser() {
      this.$api.getUsers({ key: this.key, limit: 150 }).then(res => {
        this.users = res.result.users.map(i => {
          let eu = this.group_users.filter(e => e.ID == i.ID);
          i["has_user"] = false;
          if (eu.length > 0) {
            i["has_user"] = true;
          }
          i.checked = false;
          return i;
        });
        this.page = res.result.page;
      });
    },
    createGroup() {
      if (!this.group_form.title) {
        this.$message.error({ message: "请输入群名称" });
        return;
      }
      this.$api.createGroup(this.group_form).then(res => {
        if (res.code == 200) {
          this.group_form = {};
          const room = res.result.room;
          this.$api
            .addUserToRoom({
              id: room.ID,
              ids: this.choosed.map(m => m.ID).join(",")
            })
            .then(res1 => {
              if (res1.code == 200) {
                this.$message.success({ message: res.msg });
                this.$emit("created", room);
                // this.$emit("complete_event", true);
                this.showGroup = false;
                // this.groups = [res.result.room].concat(groups);
              }
            });
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.chat-new-group {
  /deep/ .el-dialog__body {
    padding-top: 0;
    padding-bottom: 0;
  }
  font-size: 14px;
  .user {
    height: 480px;
    display: flex;
    justify-content: space-between;
    // align-items: center;
    // border: 1px dashed;
    .all {
      width: 63%;
      height: 100%;
      .all-search {
        margin: 10px 0;
      }
      /deep/ .all-search.el-input {
        width: 200px;
        height: 30px;
        .el-input__inner {
          height: 30px;
          border-radius: 15px;
        }
        .el-input__icon {
          font-weight: bold;
        }
      }
      .box {
        height: calc(100% - 40px);
        overflow-y: auto;
        color: hsla(0, 0%, 20%, 1);
        .item {
          margin-right: 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 40px;
          // border: 1px dashed deepskyblue;
        }
      }
    }
    .choosed {
      padding-left: 20px;
      width: 37%;
      height: 100%;
      border-left: 1px solid hsla(0, 0%, 90%, 1);
      .title {
        height: 40px;
        line-height: 40px;
      }
      .box {
        height: calc(100% - 40px);
        overflow-y: auto;
        color: hsla(0, 0%, 20%, 1);
        .item {
          height: 40px;
          line-height: 40px;
          // border: 1px dashed red;
        }
      }
    }
  }
  .group-form {
    /deep/ .pro-input {
      width: 300px;
      height: 40px;

      .el-input__inner {
        background: hsla(0, 0%, 94%, 1);
        border-radius: 20px;
      }
    }
  }
  .footer {
    // border: 1px dashed red;
    text-align: center;
    /deep/ .el-button {
      width: 120px;
      height: 36px;
    }
  }
}
</style>